<div class="page-chat content-layout" fxLayout="column">

    <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column" [guide]="route">

        <calsoft-breadcrumbs [url]="primaryTitle" [currentPage]="primaryTitle" [header]="'primary'">
        </calsoft-breadcrumbs>


        <div fxLayout="column" fxLayoutGap="24px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <button (click)="back()" [attr.guide]="route + '_back_header'" matTooltip="Back"
                                mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            {{title}}
                        </div>
                    </div>

                    <div class="padding-10" fxLayout="column" fxLayoutGap="10px">
                        <div class="editSets1">
                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                <span>Excel</span>
                            </div>
                            <div class="products-padding" fxLayout="row" fxLayoutAlign="start center">

                                <mat-stepper orientation="{{orientation}}" style="width: 100%;" fxFlex [linear]="true"
                                    #stepper>

                                    <mat-step [stepControl]="secondFormGroup" label="Import Excel">

                                        <form [formGroup]="secondFormGroup">
                                            <div *ngIf="!fileUpload">
                                                <div class="upload">
                                                    <input type="file" class="form-control"
                                                        [attr.guide]="route + '_file_input'"
                                                        (change)="onFileSelected($event)" placeholder="Upload file"
                                                        accept=".csv,.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">

                                                </div>

                                                <p *ngIf="fileError" style="color: red; margin-top: 6px; font-size: 13px;">
                                                    ⚠ {{ fileError }}
                                                </p>

                                                <div fxLayout="row" class="padding-10" fxLayoutAlign="start center"
                                                    fxLayoutGap="5px" *ngIf="selectedFile">
                                                    <button mat-raised-button [attr.guide]="route + '_upload_file_btn'"
                                                        (click)="uploadFile()">Upload</button>
                                                </div>
                                            </div>




                                            <div *ngIf="fileUpload" class="products-padding" fxLayout="row">
                                                File Uploaded Successfully Procced to Next Step
                                            </div>


                                        </form>
                                        <div fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">


                                            <button [attr.guide]="route + '_step1_next'" ngStyle.lt-sm="width: 100%;"
                                                (click)="goToStep3(stepper)" mat-raised-button
                                                color="primary">Next</button>

                                        </div>



                                    </mat-step>

                                    <mat-step [stepControl]="firstFormGroup" label="XL Mapper">


                                        <div [formGroup]="firstFormGroup" class="padding-11">

                                            <div class="editSets1">
                                                <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                                    <span>Source Mapper</span>
                                                </div>


                                                <div>
                                                    <div class="result" fxLayout="column">

                                                        <div color="warn">
                                                            <div fxLayout="row wrap" fxFlex="100">
                                                                <div color="warn" fxFlex="100">
                                                                    <div formArrayName="sourceMapper" *ngFor="let Profileadd of firstFormGroup.get
                                                                ('sourceMapper')['controls']; let i = index">
                                                                        <div [formGroupName]="i">

                                                                            <div class="input-row" fxLayout="row"
                                                                                fxLayout.sm="column"
                                                                                fxLayout.xs="column" fxLayoutGap="10px">

                                                                                <mat-form-field appearance="outline"
                                                                                    fxFlex>
                                                                                    <mat-label>Form Fields
                                                                                        Mapper</mat-label>
                                                                                    <mat-select
                                                                                        [disableOptionCentering]="true"
                                                                                        #singleSelect
                                                                                        formControlName="fieldMapper"
                                                                                        autocomplete="off">
                                                                                        <mat-option [disabled]="true"
                                                                                            *ngFor="let key of mapperKeys"
                                                                                            [value]="key">
                                                                                            {{ key }}
                                                                                        </mat-option>
                                                                                    </mat-select>
                                                                                </mat-form-field>

                                                                                <mat-form-field appearance="outline"
                                                                                    fxFlex>
                                                                                    <mat-label>Form Fields</mat-label>
                                                                                    <mat-select
                                                                                        [disableOptionCentering]="true"
                                                                                        #singleSelect
                                                                                        formControlName="formFields"
                                                                                        autocomplete="off">
                                                                                        <mat-option
                                                                                            *ngFor="let key of mapper"
                                                                                            [value]="key.name">
                                                                                            {{ key.title }}
                                                                                        </mat-option>
                                                                                    </mat-select>
                                                                                </mat-form-field>


                                                                                <button
                                                                                    [attr.guide]="'custom-excel-mapper-btn-1' + '__' + sanitizeUrl(url)"
                                                                                    [disabled]="i<1"
                                                                                    fxLayoutAlign="center end"
                                                                                    mat-icon-button color="warn"
                                                                                    (click)="removeOption(i)">
                                                                                    <mat-icon>
                                                                                        delete
                                                                                    </mat-icon>
                                                                                </button>

                                                                            </div>
                                                                        </div>

                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">


                                            <button [attr.guide]="route + '_step2_next'" ngStyle.lt-sm="width: 100%;"
                                                (click)="goToStep(stepper)" mat-raised-button
                                                color="primary">Next</button>

                                        </div>

                                    </mat-step>

                                    <mat-step label="Data Preview">

                                        <div *ngIf="mappedPreview.length > 0" class="card p-4 shadow-sm">

                                            <h5 class="mb-3">Mapped Data Preview</h5>

                                            <div [ngClass]="mappedPreview.length>5?'example-container':'none'">

                                                <table mat-table [dataSource]="mappedPreview" class="w-full">

                                                    <ng-container *ngFor="let column of displayedFormFields"
                                                        [matColumnDef]="column">
                                                        <mat-header-cell *matHeaderCellDef> {{ column
                                                            }}</mat-header-cell>
                                                        <mat-cell *matCellDef="let row">
                                                            {{ row[column] }}
                                                        </mat-cell>
                                                    </ng-container>

                                                    <ng-container matColumnDef="actions">
                                                        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                                                        <mat-cell *matCellDef="let row">
                                                            <button
                                                                [attr.guide]="'custom-excel-mapper-btn-2' + '__' + sanitizeUrl(url)"
                                                                (click)="deleteRow(row)" mat-icon-button>
                                                                <mat-icon>delete</mat-icon>
                                                            </button>

                                                        </mat-cell>
                                                    </ng-container>

                                                    <mat-header-row
                                                        *matHeaderRowDef="displayedFormFields.concat(['actions'])"></mat-header-row>
                                                    <mat-row
                                                        *matRowDef="let row; columns: displayedFormFields.concat(['actions']);"
                                                        class="clickable"></mat-row>

                                                </table>
                                                <div style="padding: 20px;" fxLayoutAlign="center center"
                                                    *ngIf="mappedPreview?.length === 0">
                                                    No records found
                                                </div>



                                            </div>


                                        </div>


                                        <div style="padding-top: 10px;" fxLayout.lt-md="column" fxLayout.gt-sm="row"
                                            fxLayoutAlign.gt-md="end center" fxLayoutAlign.lt-md="start center"
                                            fxLayoutGap="10px">


                                            <div *ngIf="mappedPreview.length > 0; else noData">

                                                <button
                                                    [attr.guide]="'custom-excel-mapper-btn-3' + '__' + sanitizeUrl(url)"
                                                    mat-button style="color: black;" matStepperPrevious>Back</button>

                                                <button *ngIf="type == 1" [attr.guide]="route + '_final_upload_btn'"
                                                    mat-raised-button [disabled]="textNew !='Upload'"
                                                    (click)="finalUpload(stepper)" mat-raised-button>
                                                    {{textNew}}
                                                    <mat-icon *ngIf="textNew !='Upload' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>

                                                <button *ngIf="type == 0" [attr.guide]="route + '_final_upload_btn_0'"
                                                    mat-raised-button [disabled]="textNew !='Upload'"
                                                    (click)="finalUpload(stepper)" mat-raised-button>
                                                    {{textNew}}
                                                    <mat-icon *ngIf="textNew !='Upload' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>

                                            </div>

                                            <ng-template #noData>
                                                <button
                                                    [attr.guide]="'custom-excel-mapper-btn-4' + '__' + sanitizeUrl(url)"
                                                    style="color: black;" mat-raised-button
                                                    matStepperPrevious>Back</button>
                                                <p style="color: red; font-weight: bold;">No data mapped.</p>
                                            </ng-template>

                                        </div>

                                    </mat-step>

                                    <mat-step label="Done">

                                        <p>Excel Import Completed SuccessFully</p>
                                        <div fxLayout="row" fxLayoutAlign.gt-md="end center"
                                            fxLayoutAlign.lt-md="start center" fxLayoutGap="10px">
                                            <button [attr.guide]="route + '_finish_btn'" ngStyle.lt-sm="width: 100%;"
                                                (click)="goToProductPage()" mat-raised-button
                                                color="primary">Next</button>
                                        </div>
                                    </mat-step>

                                </mat-stepper>



                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>